import { useEffect, useState } from "react";

const GridOverlay = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key.toLowerCase() === "g" || e.key.toLowerCase() === "п") {
                setVisible((prev) => !prev);
            }
        };

        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, []);

    if (!visible) return null;

    return (
        <div className="pointer-events-none fixed inset-0 z-[9999] flex container-padding">
            {/* lg+ (12 колонок) */}
            <div className="container-grid hidden lg:grid">
                {Array.from({ length: 12 }).map((_, i) => (
                    <div
                        key={i}
                        className={`${i === 11 ? "border-r" : ""} border-l border-red-500/30`}
                    />
                ))}
            </div>

            {/* md (5 колонок) */}
            <div className="container-grid md:grid hidden lg:hidden">
                {Array.from({ length: 5 }).map((_, i) => (
                    <div
                        key={i}
                        className={`${i === 4 ? "border-r" : ""} border-l border-red-500/30`}
                    />
                ))}
            </div>

            {/* mobile (1 колонка) */}
            <div className="container-grid grid md:hidden">
                <div className="border-l border-r border-red-500/30 h-full" />
            </div>
        </div>
    );
};

export default GridOverlay;